module.exports = __webpack_public_path__ + "media/assets/google-sign-in-8503699dd35cfb7530c9c9929493e14c.svg";